import { ListStylesType } from '@material-tailwind/react';

export const theme = {
  list: {
    styles: {
      base: {
        list: {
          color: 'text-blue-gray-900',
        },
      },
    },
  } as ListStylesType,
};
